import React, {useState, useEffect, useRef} from 'react';
import {useForm} from 'react-hook-form';
import Steps from '../../Common/Promotion/Steps';
import BrandCarousel from '../../Common/Promotion/BrandCarousel';
import CodeEntry from '../../Common/Promotion/CodeEntry';
import Questionaire from '../../Common/Promotion/Questionaire';
import LegalAgreementCheckboxSet from '../../Common/Promotion/LegalAgreementCheckboxSet';
import Loader from '../../UI/Loader';
import {useTranslation} from 'react-i18next';
import ModalError from '../../UI/Modal/ModalError';
import PromotionPeriodNotification from '../../Common/Promotion/PromotionPeriodNotification';
// Potato Hunt Steps
import PotatoHuntStepVideo from "../../Common/PotatoHunt/PotatoHuntStepVideo";
import PotatoHuntStepGrid from "../../Common/PotatoHunt/PotatoHuntStepGrid";
import PotatoHuntStepScratchCard from "../../Common/PotatoHunt/PotatoHuntStepScratchCard";
import PotatoHuntStepThankYou from "../../Common/PotatoHunt/PotatoHuntStepThankYou";
import {CleanUrl} from "../../../utils/cleanUrl";

const PromotionCodeEntryPotatoHunt = ({promotionSettings}) => {

	const [currentStep, setCurrentStep] = useState(1);
	const [savedCountry, setSavedCountry] = useState({});
	const [formSubmitInProgress, setFormSubmitInProgress] = useState(false);
	const [formSubmitError, setFormSubmitError] = useState(false);
	const [selectedCell, setSelectedCell] = useState("odd");
	const stepsRef = useRef(null);
	const totalSteps = useRef(null);
	const {t, i18n} = useTranslation();
	const [errorMessageCode, setErrorMessageCode] = useState();
	const [errorHeadline, setErrorHeadline] = useState();
	const [errorMessage, setErrorMessage] = useState([]);
	const [userResponse, setUserResponse] = useState();
	const [participationData, setParticipationData] = useState(null);
	const imagePath = CleanUrl(`${process.env.REACT_APP_BASE_URL}/${window.drupalDirectory}/`);
	let fetchURL = "";


	useEffect(() => {
		if (stepsRef.current) {
			totalSteps.current = stepsRef.current.getAttribute('data-steps-total');
		}
	}, []);

	const handleNextStep = () => {
		setCurrentStep(currentStep + 1);
	};
	const setStep = (step) => {
		setCurrentStep(step);
	};

	const handleBackStep = () => {
		setCurrentStep(currentStep - 1);
	};

	const {register, handleSubmit, formState, setValue, getValues} = useForm({
		mode: 'onChange'
	});

	const backToStart = () => {
		setCurrentStep(1);
		setFormSubmitError(false);
	};

	const onSubmit = async (formData) => {
		if (formSubmitInProgress) return;
		setFormSubmitError(false);
		setFormSubmitInProgress(true);

		const {...restFormData} = formData;

		const formDataForSubmit = {
			...restFormData
		};


		if (window.pathPrefix !== "") {
			fetchURL = `${process.env.REACT_APP_BASE_URL}/${window.pathPrefix}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation`;
		} else {
			fetchURL = `${process.env.REACT_APP_BASE_URL}/api/joypepsico-app/v1/promotion/${window.promotionID}/participation`;
		}

		fetch(fetchURL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formDataForSubmit),
		})
			.then(response => {
				if (!response.ok) {
					if (response.status >= 500) {
						throw new Error('Server error');
					} else {
						return response.json().then(errorData => {
							throw errorData;
						});
					}
				}

				return response.json();
			})
			.then(data => {
				setParticipationData(data);
				data?.result?.user_response?.map((item, index) => {
					switch (item.response_type) {
						case 'image' :
							setUserResponse(item);
							break;
						default:
							return null;
					}
				});
				setFormSubmitError(false);
				handleNextStep();

				window.dataLayer.push({
					event: 'participation_submit',
					user_id: window.drupalSettings.pepsico_joy_eu_warehouse_reporting.user_id,
					event_id: 1.6,
					event_campaign: promotionSettings.promotion_page.promotion_title,
					message: 'ok',
					status: 'success'
				});
			})
			.catch(error => {
				setFormSubmitInProgress(false);
				setFormSubmitError(true);

				if (error.message === 'Server error') {
					setErrorMessageCode("continue_try_again");

					window.dataLayer.push({
						event: 'participation_submit',
						user_id: window.drupalSettings.pepsico_joy_eu_warehouse_reporting.user_id,
						event_id: 1.6,
						event_campaign: promotionSettings.promotion_page.promotion_title,
						message: 'generic_error',
						status: 'fail'
					});
				} else {
					setErrorMessageCode(error.user_continue);
					setErrorHeadline(error.headline);
					setErrorMessage(error.message);

					window.dataLayer.push({
						event: 'participation_submit',
						user_id: window.drupalSettings.pepsico_joy_eu_warehouse_reporting.user_id,
						event_id: 1.6,
						event_campaign: promotionSettings.promotion_page.promotion_title,
						message: error.errors,
						status: 'fail'
					});
				}
			});

	};

	return (
		<>
			<div
				className={`promo-container potato-hunt-promo-type potato-hunt-code-entry-promo-type step-${currentStep}`}>

				<Steps promotionSettings={promotionSettings} formSubmitError={formSubmitError} currentStep={currentStep}
					   stepsRef={stepsRef}/>

				{!promotionSettings.participationPeriodActive ? <>
					<PromotionPeriodNotification promotionSettings={promotionSettings}/>
				</> : <>
					{currentStep === 1 && (
						<div className="promo-step step-code-entry-form">
							<div className="form-container">
								<form className="webform-submission-promotion-form" onSubmit={handleSubmit(onSubmit)}>
									{formSubmitError && <ModalError backToStart={backToStart}
																	formSubmitInProgress={formSubmitInProgress}
																	formSubmitError={formSubmitError}
																	errorMessageCode={errorMessageCode}
																	errorMessageHeadline={errorHeadline}
																	errorMessageText={errorMessage}/>}
									<div className="promo-step-section">
										<CodeEntry handleBackStep={handleBackStep} handleNextStep={handleNextStep}
												   register={register} formState={formState}
												   promotionSettings={promotionSettings}/>
										<Questionaire handleBackStep={handleBackStep} handleNextStep={handleNextStep}
													  register={register} formState={formState}
													  promotionSettings={promotionSettings}
													  formSubmitInProgress={formSubmitInProgress}
													  formSubmitError={formSubmitError} backToStart={backToStart}/>
										<LegalAgreementCheckboxSet register={register} formState={formState}
																   promotionSettings={promotionSettings}
																   formSubmitInProgress={formSubmitInProgress}
																   formSubmitError={formSubmitError}/>
										<div className="promo-fields-group">
											<div className="promo-fields promo-action-fields">
												<div className="promo-field info">
													<p>*{t("Required fields")}</p>
												</div>
												<div className="promo-field action">
													<div>
														{formSubmitInProgress ? <Loader/> :
															<>
																<a href={window.promotionHome}
																   className="btn btn-primary-text link">{t("Go Back")}</a>
																<input type="submit" className="btn btn-primary"
																	   disabled={!formState.isValid}
																	   value={t("Submit")}/>
															</>
														}
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					)}
					{currentStep === 2 && (
						<div className="promo-step step-video">
							<div className="step-container">
								<PotatoHuntStepVideo
									imagePath={imagePath}
									onNextStep={handleNextStep}
									promotionSettings={promotionSettings}
								/>
							</div>
						</div>
					)}
					{currentStep === 3 && (
						<div className="promo-step step-grid">
							<div className="step-container">
								<PotatoHuntStepGrid
									imagePath={imagePath}
									onNextStep={handleNextStep}
									onSelectCell={setSelectedCell}
									promotionSettings={promotionSettings}
								/>
							</div>
						</div>
					)}

					{[4, 4.5].includes(currentStep) && (
						<div className="promo-step step-scratch-card">
							<div className="step-container">
								<PotatoHuntStepScratchCard
									imagePath={imagePath}
									onNextStep={handleNextStep}
									setStep={setStep}
									selectedCell={selectedCell}
									promotionSettings={promotionSettings}
									userResponse={userResponse}/>
							</div>
						</div>
					)}
					{currentStep === 5 && (
						<div className="promo-step step-thenk-you">
							<div className="step-container">
								<PotatoHuntStepThankYou
									participationData={participationData}
									imagePath={imagePath}
									onNextStep={handleNextStep}
									onSelectCell={setSelectedCell}
									promotionSettings={promotionSettings}
								/>
							</div>
						</div>
					)}
				</>
				}
			</div>
		</>
	);
}

export default PromotionCodeEntryPotatoHunt;
